<template>
    <div class="logo-spacer">
        <div id="logo-container">

          <div id="bal-container">
            <div id="bal-kaal"></div>
              <div id="bal-nummer">
                <!-- <img id="balnummer" src="static/svg/bal_nummer.svg"> -->
                <svg id="balnummer" viewBox="0 0 175 175" width="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
                    <g style="transform-origin:50% 50%;">
                        <text text-anchor="middle" x="50%" y="63%" font-size="100px">23</text>
                        <line x1="17%" y1="69%" x2="83%" y2="69%" stroke="black" stroke-width="5" ></line>
                    </g>
                </svg>
              </div>
            <div id="bal-belichting"></div>
          </div>

    <!--       <div id="lente-skin">
            <div id="cloud-1"></div>
            <div id="cloud-2"></div>
            <div id="sun"></div>
            <div id="bird"></div>
          </div> -->


          <div id="hoger"></div>

<!--           <div id="lente-skin-bottom">
              <svg id="grass" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 340.87 288.78"><defs><linearGradient id="linear-gradient" x1="5.84" y1="277.73" x2="324.53" y2="277.73" gradientUnits="userSpaceOnUse"><stop offset="0.16" stop-color="#bacf42"/><stop offset="1" stop-color="#8eb340"/></linearGradient><linearGradient id="linear-gradient-2" x1="146.55" y1="188.53" x2="320.52" y2="88.09" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-3" x1="210.51" y1="175.1" x2="306.24" y2="175.1" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-4" x1="96.55" y1="236.77" x2="181.16" y2="90.22" gradientUnits="userSpaceOnUse"><stop offset="0.04" stop-color="#bacf42"/><stop offset="0.15" stop-color="#b0c942"/><stop offset="0.42" stop-color="#9dbd41"/><stop offset="0.7" stop-color="#92b540"/><stop offset="1" stop-color="#8eb340"/></linearGradient><linearGradient id="linear-gradient-5" x1="21.27" y1="165.91" x2="89.61" y2="138.29" xlink:href="#linear-gradient"/></defs><title>grass</title><path d="M324.53,277.73c0,6.1-71.34,11-159.35,11s-159.34-4.95-159.34-11,71.34-11,159.34-11S324.53,271.64,324.53,277.73Z" fill="url(#linear-gradient)"/><path d="M192.62,268.33s-68.49-160,77-268.33c0,0,15.18,200.61-59.53,269.27Z" fill="url(#linear-gradient-2)"/><path d="M210.51,269.59s15.57-154.32,95.73-190.23c0,0-27.24,162.51-78.6,191.49Z" fill="url(#linear-gradient-3)"/><path d="M196.51,270.85s7-132.28-105.07-232.43c0,0-20.23,178.26,63,231.8Z" fill="url(#linear-gradient-4)"/><path d="M3.09,20.79C1.55,19.37-2.72,228,103.9,274l30.35-1.26S105.82,114.64,3.09,20.79Z" fill="url(#linear-gradient-5)"/><path d="M266.16,271.16s13.42-111.49,74.71-146c0,0,1.17,124.24-58.95,147.86C281.92,273.05,269.08,277.77,266.16,271.16Z" fill="#6db344"/><path d="M273.75,270.69s23.93-71.34-45.53-128.5c0,0-16.93,98.26,33.85,128.5C262.07,270.69,265,277.77,273.75,270.69Z" fill="#6db344"/><path d="M113.82,180s-9.34,82.19,20.43,94.48c0,0,15.76,2.83,22.18-1.42C156.43,273.05,158.18,215.42,113.82,180Z" fill="#2daa4a"/><path d="M80.16,273.36S6.23,254.47,0,185.81c0,0,92.61,30.87,96.5,86.3C96.5,272.11,90.28,277.14,80.16,273.36Z" fill="#6db344"/><path d="M97.28,275.88s-15.56-9.44,3.89-40.31c0,0,22.57,27.72,7,41.57C108.18,277.14,98.06,277.77,97.28,275.88Z" fill="#2daa4a"/><path d="M255.26,274.62s12.46-12.59,48.25-8.81c0,0,7,3.15,10.9-1.26,0,0,3.89,23.93-54.48,13.85C259.93,278.4,252.15,275.88,255.26,274.62Z" fill="#2daa4a"/></svg>

              <div id="flower-1"></div>
              <div id="flower-2"></div>
              <div id="flower-3"></div>
          </div> -->

          <div id="lager"></div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
    #bal-container, #bal-container * {
        will-change: transform;
    }
    #lager{
        top: 9%;
        left: 21%;
        width:215px;
    }
    #hoger{
        top: -10%;
        left: 1%;
        width:215px;
    }
</style>

<script>
    /* eslint-disable */

    import { TweenMax, TimelineMax } from '@/vendor';

    export default {
        data()
        {
            return {
                mainTimeline: null
            };
        },

        mounted()
        {
            // TweenMax.set(["#logo-container div", "#logo-container img"], {force3D: true, backfaceVisibility: "hidden", rotationZ: '0.01deg', z:0.01});

            if( window.innerWidth < 600 )
            {
                TweenMax.set( '#logo-container', { scale: 0.8 });
            }

            this.setupMainAnimation();
            this.mainTimeline.play();
        },

        methods: {
            setupMainAnimation()
            {
                /* temp */
                // TweenMax.set( '#hoger, #lager', { autoAlpha: 0 });

                /* end of temp */

                this.mainTimeline = new TimelineMax({ paused:true });
                this.mainTimeline.add( 's1','start' );
                this.mainTimeline.add( 's2','s1+=3' );
                this.mainTimeline.add( 's3','s2+=3' );
                this.mainTimeline.add( 's4','s3+=3' );

                let sY = 0.65;
                let sX = 0.9;

                let scaleTl = new TimelineMax({ paused:true });
                scaleTl.fromTo( '#balnummer', 1, { scaleX: sX, scaleY: sY }, { scaleX: 1, scaleY: 1, ease: Linear.easeNone }, 0 );
                scaleTl.to( '#balnummer', 1, { scaleX: sX, scaleY: sY, ease: Linear.easeNone }, 1 );

                this.mainTimeline.set( '#balnummer', { willChange:'transform' }, 's1+=1.5' );

                // Scene 1
                this.mainTimeline.from( '#bal-container', 3.7, {scale:0, ease:Expo.easeOut }, 's1' );
                this.mainTimeline.to( '#balnummer', 0.1, {y:300, repeat:3, repeatDelay:0.1, onComplete:this.setNumber, ease:Linear.easeOut }, 's1' );
                this.mainTimeline.fromTo( scaleTl, 0.1, { progress: 0 }, { progress: 1, repeat: 3, repeatDelay:0.1 }, 's1' );

                this.mainTimeline.to( '#balnummer', 0.3, {y:300, onComplete:this.setNumber, ease:Linear.easeOut }, '.6' );
                this.mainTimeline.fromTo( scaleTl, 0.3, { progress: 0 }, { progress: 1 }, '.6' );

                this.mainTimeline.to( '#balnummer', 1.3, {y:150, ease:Expo.easeOut }, 1.2 );
                this.mainTimeline.fromTo( scaleTl, 0.8, { progress: 0 }, { progress: 0.5 }, 1.2 );

                this.mainTimeline.from( '#hoger', 2, {rotation:-1080, scale:0.5, opacity:0, ease:Expo.easeInOut }, 1 );
                this.mainTimeline.from( '#lager', 2, {rotation:-1080, scale:0.5, opacity:0, ease:Expo.easeInOut }, 1.3 );

                this.mainTimeline.from( '#sun', 0.5, { y: 10, autoAlpha: 0 }, 2.5 );
                this.mainTimeline.from( '#cloud-1', 0.4, { x: '50%', autoAlpha: 0, ease: Sine.easeOut }, 3 );
                this.mainTimeline.from( '#cloud-2', 0.4, { x: '-50%', autoAlpha: 0, ease: Sine.easeOut }, 3.2 );

                // bird fly anim

                this.mainTimeline.from( '#bird', 0.3, { opacity: 0 }, 2.8 );
                this.mainTimeline.from( '#bird', 2, { x: 100 }, 2.8 );
                this.mainTimeline.to( '#bird', 0.3, { y: -20, yoyo: true, repeat: 5, ease: Sine.easeIn }, 2.8 );

                TweenMax.set( '#grass > path', { transformOrigin: '50% 100%' });
                this.mainTimeline.staggerFrom( '#grass > path', 0.3, { scaleY: 0, ease: Back.easeOut }, 0.1, 2 );

                this.mainTimeline.from( '#flower-1', 0.2, { rotation: 180, scale: 0, opacity: 0 }, 3.1 );
                this.mainTimeline.from( '#flower-2', 0.4, { rotation: 270, scale: 0, opacity: 0 }, 3.3 );
                this.mainTimeline.from( '#flower-3', 0.3, { rotation: -180, scale: 0, opacity: 0 }, 3.5 );


                // flower-1


                this.mainTimeline.add( 'complete' );
            },

            setNumber()
            {
                TweenMax.set(["#balnummer"], {y:0});
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/LogoAnim.vue